import { Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone } from '../../../components/Phone';
import { PROJECTS_PREVIEW } from '../../../constants/projects';

const ProjectsPreview = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const navigate = useNavigate();
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % PROJECTS_PREVIEW.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      width="100%"
      height="600px"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="40px"
    >
      {PROJECTS_PREVIEW.map((project, index) => {
        const position =
          index === activeIndex
            ? 'center'
            : index ===
                (activeIndex - 1 + PROJECTS_PREVIEW.length) %
                  PROJECTS_PREVIEW.length
              ? 'left'
              : 'right';

        return (
          <Box
            key={project.id}
            position="absolute"
            transition="all 1s cubic-bezier(0.22, 1, 0.36, 1)"
            transform={{
              base:
                position === 'center'
                  ? 'translateX(0%) scale(0.65) rotate(0deg)'
                  : position === 'left'
                    ? 'translateX(-20%) scale(0.55) rotate(-6deg)'
                    : 'translateX(20%) scale(0.55) rotate(6deg)',
              md:
                position === 'center'
                  ? 'translateX(0%) scale(0.80) rotate(0deg)'
                  : position === 'left'
                    ? 'translateX(-30%) scale(0.70) rotate(-6deg)'
                    : 'translateX(30%) scale(0.70) rotate(6deg)',
            }}
            opacity={position === 'center' ? 1 : 0.5}
            zIndex={position === 'center' ? 2 : 1}
            onClick={() => {
              if (position === 'center')
                navigate(`/projects`, { state: { scrollTo: project.id } });
            }}
          >
            <Phone screenshot={project.image} />
          </Box>
        );
      })}
    </Box>
  );
};

export default ProjectsPreview;
